import { useMemo } from 'react';
import type { MessageDescriptor } from 'react-intl';

import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { Text, TextType } from 'ui-components/components/text';
import { GuidService } from 'ui-components/services/guid-service';

import ModalPortal from '../../../../../../components/modal-portal';
import styles from './audit-details-modal.styles.module.less';

type AuditLoadingModalProps = {
  onClose: () => void;
  titleMessage: MessageDescriptor;
};

export const AuditLoadingModal = ({ onClose, titleMessage }: AuditLoadingModalProps) => {
  const modalHeaderId = useMemo(() => GuidService.newGuid(), []);

  return (
    <ModalPortal onClose={onClose}>
      <Modal className={styles.modal} modalHeaderId={modalHeaderId}>
        <ModalHeader closeModal={onClose} id={modalHeaderId}>
          <Text textType={TextType.H3} value={titleMessage} />
        </ModalHeader>
        <ModalBody className={styles['modal-body']}>
          <div className={styles['loading-wrapper']}>
            <LoadingIndicator />
          </div>
        </ModalBody>
      </Modal>
    </ModalPortal>
  );
};
